export default __webpack_public_path__ + "static/media/help.ed0bd4c7.svg";